<template>
  <div>

    <!-- [ Modal form Save Task Tree ] start -->
    <sweet-modal blocking :title="$t('modal_saveTaskTree')" ref="saveTaskTreeProject" class="modal" v-on:close="closeModal">
      <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input v-model="form.name" size="mini" :label="$t('modal_name')"></el-input>
        </el-form-item>
        <el-form-item prop="description">
          <el-input v-model="form.description" size="mini" :label="$t('modal_description')"></el-input>
        </el-form-item>

        <el-form-item class="modal__btn">
          <el-button @click="modalCancel('saveTaskTreeProject')">{{$t('general_cancel')}}</el-button>
          <el-button @click="test('form')" type="primary">{{$t('general_submit')}}</el-button>
          <!--<el-button @click="test" type="primary">test</el-button>-->
        </el-form-item>
      </el-form>
    </sweet-modal>
    <!-- [ Modal form Save Task Tree ] end -->

  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  components: {
    SweetModal,

  },
  props: ['saveTaskTreeProject'],
  data() {
    return {
      form: {
        name: '',
        description: ''
      },
      rules: {
        name: [{
          required: true,
          message: 'Field is required',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: 'Field is required',
          trigger: 'blur'
        }],
      }
    }
  },
  methods: {
    modalCancel(ref) {
      this.$refs[ref].close();
    },
    closeModal() {
      this.$refs['form'].resetFields();
    },
    test(){
      let loader = this.$loading.show();
      setTimeout(()=>{
        this.submitForm();
        loader.hide()
      }, 100)
    },
    submitForm(form) {
      try {
        const valid = this.$refs['form'].validate();
        if (valid) {
          this.getTreeScreen()
        }
      } catch (err) {
        console.log(err)
      }
    },
    getTreeScreen(){
      this.$emit('getTreeScreen');
    },
    submitFormWithFileUrl(fileUrl){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      const url = `/api/v1/projects/createTemplate?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}`;
      axios.post(url, {
        name: this.form.name,
        description: this.form.description,
        fileUrl: fileUrl
      }).then(response => {
        this.$refs.saveTaskTreeProject.close();
        this.notification("Success", "Save task tree", "success");
        loader.hide();
      }).catch(error => {
        loader.hide()
      });
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: right;
  }
}
</style>
